// R7-6 — THE SIDE MENU'S LINE ICONS, MOVED VERBATIM OUT OF App.tsx.
//
// The comment below states a law that was never checked: "a new room adds one line here and cannot
// render iconless". It could not be checked, because a `Partial<Record<Page, ReactNode>>` full of
// JSX inside a TSX file was unreachable from `scripts/`. R7-1's loader makes it reachable, so the
// law is now enforced: every room the side menu actually lists has its OWN icon here, and the Star
// fallback is a backstop rather than the thing half the menu quietly renders.
//
// Moved VERBATIM.
import type { ReactNode } from "react";
import {
  ScrollText,
  BookOpen,
  DoorOpen,
  Gauge,
  Hand,
  Hash,
  House,
  MapPinned,
  Moon,
  Orbit,
  PersonStanding,
  Send,
  Sofa,
  SquareStack,
  Stamp,
  Star,
  WandSparkles,
  LifeBuoy, FileText, ShieldCheck, CircleHelp,
} from "lucide-react";
import type { Page } from "../lib/pages";

// HP3: the sidebar's own line icons, in the mockup's style. Deliberately NOT reusing
// homeMenuItems' icons: those belong to the big room cards further down the page, which are
// staying as they are. Keyed by Page, so a new room adds one line here and cannot render iconless.
export const MENU_ICONS: Partial<Record<Page, ReactNode>> = {
  home: <House size={17} strokeWidth={1.5} />,
  "my-room": <DoorOpen size={17} strokeWidth={1.5} />,
  // LR1-13: the Living Room sits directly under My Room in the menu, so its icon sits here too.
  "living-room": <Sofa size={17} strokeWidth={1.5} />,
  dashboard: <Gauge size={17} strokeWidth={1.5} />,
  "spell-book": <WandSparkles size={17} strokeWidth={1.5} />,
  "ask-lala": <Send size={17} strokeWidth={1.5} />,
  library: <BookOpen size={17} strokeWidth={1.5} />,
  seals: <Stamp size={17} strokeWidth={1.5} />,
  numerology: <Hash size={17} strokeWidth={1.5} />,
  astrology: <Orbit size={17} strokeWidth={1.5} />,
  tarot: <SquareStack size={17} strokeWidth={1.5} />,
  "human-design": <PersonStanding size={17} strokeWidth={1.5} />,
  astrocartography: <MapPinned size={17} strokeWidth={1.5} />,
  // AKASHIC-1: a scroll, for a room of records. R7 refused the push while it fell back to Star,
  // which is the icon a room gets when nobody chose one for it.
  akashic: <ScrollText size={17} strokeWidth={1.5} />,
  dreams: <Moon size={17} strokeWidth={1.5} />,
  palmistry: <Hand size={17} strokeWidth={1.5} />,
  // HELP-ON-MOBILE (2026-08-08): her four help doors get their OWN icons rather than falling through
  // to the Star. R25's shape one size down — an unrostered key falling back to a plausible wrong
  // icon is worse than a visibly missing one, and four identical stars under the rooms would read as
  // four more rooms.
  contact: <LifeBuoy size={17} strokeWidth={1.5} />,
  terms: <FileText size={17} strokeWidth={1.5} />,
  privacy: <ShieldCheck size={17} strokeWidth={1.5} />,
  faq: <CircleHelp size={17} strokeWidth={1.5} />,
};
export function MenuIcon({ page }: { page: Page }) {
  return <span className="site-sidebar__icon" aria-hidden="true">{MENU_ICONS[page] || <Star size={17} strokeWidth={1.5} />}</span>;
}
